import { useQuery } from "react-query";
import { getUnverifiedInvoiceCount } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

const useGetUnverifiedInvoiceCount = () => {
  return useQuery("GetUnverifiedInvoiceCount", getUnverifiedInvoiceCount, {
    refetchOnWindowFocus: false,
  });
};

export default useGetUnverifiedInvoiceCount;
